import { Vue, Component } from 'vue-property-decorator';
import { Form } from 'element-ui';
import { ILOGPRE } from '@/types/base.d';
import { IEditques } from '@/types/question.d';
import api from '@/api/question';

@Component
export default class formMixin extends Vue {
  public log: ILOGPRE = {
    name: '题库管理 - 模态框 -',
    component: 'question/components/edit/index',
  };

  public form: IEditques = {
    title: '',
    qstType: '',
    answer: '',
    options: 0,
  }

  private loading: boolean = false;

  public $refs!: {
    form: Form,
  };

  private rules: any = {
    title: [
      { required: true, message: '标题不能为空' },
    ],
    qstType: [
      { required: true, message: '类型不能为空' },
    ],
    options: [
      { required: true, message: '选项数不能为空' },
    ],
    answer: [
      { required: true, message: '答案不能为空' },
    ],
  };

  /* eslint-disable class-methods-use-this */
  reset(close: boolean, refrsh: boolean) {}

  /**
   * @author liangyongmou
   * @desc 重置表单
   * @param 空
   */
  resetForm() {
    this.$refs.form.resetFields();
  }

  /**
   * @author liangyongmou
   * @desc 添加/编辑机构信息
   * @param { string } title 标题
   */
  submit(title: string) {
    this.loading = true;
    this.$refs.form.validate((valid: boolean) => {
      if (valid) {
        this.$log({
          title: `${this.log.name}提交`,
          component: this.log.component,
        });
        const data:any = new FormData();
        if (this.form.file) data.append('file', this.form.file as Blob);
        data.append('id', this.form.id);
        data.append('title', this.form.title);
        data.append('type', this.form.qstType);
        data.append('option', this.form.options);
        data.append('answer', this.form.answer);
        api.editQuestion(data).then(() => {
          this.reset(true, true);
          this.loading = false;
        /* eslint-disable no-return-assign */
        }).catch(() => (this.loading = false));
      } else this.loading = false;
    });
  }
}
